export const Laboratorio = { idGrupo: 1, Color: -6545, Nombre: 'Laboratorio'};
export const localeDoctorSort = (da, db) => {
  return da.Nombre.localeCompare(db.Nombre);
};